<template>
  <el-upload
    ref="uploadForm"
    class="upload-demo"
    :limit="1"
    :action="uploadUrl"
    :on-change="handleChange"
    :on-success="success"
    :on-preview="previewFun"
    :on-remove="removeFun"
    :headers="{Accept:'application/json, text/plain, */*'}"
    :with-credentials="true"
    :http-request="httpRequest"
    :file-list="list">
    <el-button size="mini" type="success">点击上传</el-button>
  </el-upload>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadFileSysc",
  props:{
    url:String,
    hostUrl:String,
    uploadUrl:{
      type:String,
      default(){
        return ""
      }
    }
  },
  model: {
    prop: "url", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "success", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  data(){
    return {
      list:[]
    }
  },
  mounted() {
    this.url&&(this.list=[{name:'文件',url:this.hostUrl+"/"+this.url}])
  },
  methods:{
    handleChange(file, fileList) {
      // console.log(file, fileList)
    },
    success(response, file, fileList){
      console.log(response, file, fileList)
      let list=[]
      var that=this;
      let file_path=response.data.path.replace('\\','/').replace('//','/');
      that.$emit("success",file_path)
    },
    removeFun(file, fileList){
      this.$emit("success","")
    },
    previewFun(file){
      window.open(file.url);
    },
    httpRequest(item){
      var that=this;
      // 在这里进行一系列的校验
      let formData = new FormData();
      formData.append("file",item.file);
      // console.log(formData)
      axios.post(item.action,formData).then(res=>{
        if(res){
          let file_path=res.data.data.path.replace('\\','/').replace('//','/');
          that.$emit("success",file_path)
        }
      },err=>{
        that.clearFlies()
      })
    },
    clearFlies() {
      this.$refs.uploadForm.clearFiles();
    },
  },
  watch:{
    url(n){
      if(n){
        this.list=[{name:'文件',url:this.hostUrl+"/"+n}]
      }else {
        this.list=[]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(../common.scss);
.file-fm{
  justify-content: space-between;
  width: 300px;
  .file-fm-rt{
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/UploadFileSysc.vue